/**
 * @generated SignedSource<<0efb691d328f7e26f9e640fdbf2f46d2>>
 * @relayHash 12e25e19caded8abedaf08ee3bcf8397
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 032fbf380d33e8a7b06023c1bb0e861577535c454d6e41b937cf41106fae03a6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import includeUserAccessEnabledForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access-enabled.relayprovider';
import includeUserAccess_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "032fbf380d33e8a7b06023c1bb0e861577535c454d6e41b937cf41106fae03a6",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessrelayprovider": includeUserAccess_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessenabledrelayprovider": includeUserAccessEnabledForge_provider
    }
  }
};

export default node;
